import {
  AllocationTypeKey,
  AllocationTypes,
} from '../../models/token-allocation.model';
import { TokenTypeKey, TokenTypes } from '../../models/token-setting.model';
import { TokenUseTypeKey } from '../../models/token-use-event.model';

export function tokenTypeLabel(tokenType: TokenTypeKey): string {
  switch (tokenType) {
    case TokenTypeKey.Quote:
      return TokenTypes.QUOTE.name;
    case TokenTypeKey.CAD:
      return TokenTypes.CAD.name;
  }
}

export function allocationTypeLabel(allocationType: AllocationTypeKey): string {
  switch (allocationType) {
    case AllocationTypeKey.IN_PLAN:
      return AllocationTypes.IN_PLAN.name;
    case AllocationTypeKey.CUSTOMER_PURCHASE:
      return AllocationTypes.CUSTOMER_PURCHASE.name;
    case AllocationTypeKey.COMPLIMENTARY:
      return AllocationTypes.COMPLIMENTARY.name;
  }
}

export function useTypeLabel(useType: TokenUseTypeKey): string {
  switch (useType) {
    case TokenUseTypeKey.TOKEN_CONSUME:
      return 'Consume';
    case TokenUseTypeKey.TOKEN_REFUND:
      return 'Refund';
    case TokenUseTypeKey.TOKEN_REFUND_MANUAL:
      return 'Manual refund';
    case TokenUseTypeKey.ON_DEMAND:
      return 'On demand';
    case TokenUseTypeKey.FAILED_NO_BUDGET:
      return 'Failed (no budget)';
  }
}

export type UseTypeSeverity = 'success' | 'info' | 'warn' | 'danger';

export function useTypeSeverity(useType: TokenUseTypeKey): UseTypeSeverity {
  switch (useType) {
    case TokenUseTypeKey.TOKEN_CONSUME:
      return 'info';
    case TokenUseTypeKey.TOKEN_REFUND:
    case TokenUseTypeKey.TOKEN_REFUND_MANUAL:
      return 'success';
    case TokenUseTypeKey.FAILED_NO_BUDGET:
      return 'danger';
    case TokenUseTypeKey.ON_DEMAND:
      return 'warn';
  }
}

export function relativeTimestamp(iso: string): string {
  const date = new Date(iso);
  const diffSeconds = Math.round((date.getTime() - Date.now()) / 1000);
  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  const abs = Math.abs(diffSeconds);

  if (abs < 60) {
    return rtf.format(diffSeconds, 'second');
  }
  const diffMinutes = Math.round(diffSeconds / 60);
  if (Math.abs(diffMinutes) < 60) {
    return rtf.format(diffMinutes, 'minute');
  }
  const diffHours = Math.round(diffMinutes / 60);
  if (Math.abs(diffHours) < 24) {
    return rtf.format(diffHours, 'hour');
  }
  const diffDays = Math.round(diffHours / 24);
  if (Math.abs(diffDays) < 30) {
    return rtf.format(diffDays, 'day');
  }
  const diffMonths = Math.round(diffDays / 30);
  if (Math.abs(diffMonths) < 12) {
    return rtf.format(diffMonths, 'month');
  }
  return rtf.format(Math.round(diffMonths / 12), 'year');
}
